"use client";

import { useLayoutEffect } from "react";
import { usePathname } from "next/navigation";
import { useThemePreference } from "@/hooks/use-app-theme";
import { applyAppTheme, clearAppTheme, isThemedPath, subscribeSystemTheme } from "@/lib/theme/app-theme";

export function AppThemeSync() {
  const preference = useThemePreference();
  const themed = isThemedPath(usePathname());

  useLayoutEffect(() => {
    if (!themed) {
      clearAppTheme();
      return;
    }
    applyAppTheme(preference);
    if (preference !== "system") return;
    return subscribeSystemTheme(() => applyAppTheme("system"));
  }, [preference, themed]);

  useLayoutEffect(() => clearAppTheme, []);

  return null;
}
